import { useRegisterDisplayedAttribute } from 'state/tracking';
import { useUnit } from 'state/unit';

export type PodcastArtworkProps = React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>;

const PodcastArtwork: React.FC<PodcastArtworkProps> = (props) => {
  const unit = useUnit();

  useRegisterDisplayedAttribute(unit?.resultId, 'episodeArtwork');

  return (
    <img
      alt="podcast episode artwork"
      src={unit?.episode.thumbnailUrl}
      {...props}
    />
  );
};

export default PodcastArtwork;
